const styels = theme => ({
  hero: {
    backgroundColor: "#FDFDF9",
    position: "relative"
  },
  taglineContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "#ffffff"
  },
  headline: {
    marginBottom: 24
  },
  subheading: {
    fontWeight: 300,
    marginBottom: 24,
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.1rem"
    }
  },
  ctaContainer: {
    display: "flex",
    justifyContent: "space-between"
  },
  ctaButton: {
    textTransform: "initial",
    opacity: 0.9,
    "&:first-child": {
      marginRight: 24
    },
    "& span": {
      fontSize: "1rem"
    }
  },
  ctaButtonContained: {
    "& $ctaButtonIcon": {
      fill: "#ffffff"
    }
  },
  ctaButtonIcon: {
    marginRight: 8,
    fill: "#2296f3"
  },
  ctaButtonWhite: {
    backgroundColor: "#ffffff",
    color: "#2296f3",
    "&:hover": {
      backgroundColor: "rgb(228,228,228)"
    }
  },
  badges: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: [[0, -8]]
  },
  [theme.breakpoints.down("xs")]: {
    mask: {
      display: "none"
    },
    taglineContainer: {
      position: "relative",
      color: "rgba(0,0,0,0.87)",
      padding: "24px 16px"
    },
    headline: {
      textAlign: "left",
      fontSize: "1.5rem",
      fontWeight: 500,
      marginTop: 0,
      marginBottom: 16
    },
    subheading: {
      textAlign: "left",
      fontSize: "0.875rem",
      marginBottom: 12
    },
    offer: {
      fontWeight: "normal",
      fontSize: "1rem"
    },
    offerEm: {
      color: "#17c303"
    },
    ctaContainer: {
      width: "100%",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      alignItems: "center"
    },
    ctaButton: {
      marginBottom: 0,
      "&:first-child": {
        marginRight: 16
      }
    }
  }
});

export default styels;



// WEBPACK FOOTER //
// ./src/screens/Home/HeroStyles.js